import { Box } from "@mui/material";
import type { ReactElement } from "react";
import { Link } from "react-router";

import { useTT } from "../../useTT.ts";

const defaultLogo = "fidoo_by_direct.svg";

export type AppLogoProps = {
  url?: string | null;
  openInNewTab?: boolean;
} & LogoElementProps;

export function AppLogo({
  url,
  openInNewTab = false,
  ...rest
}: AppLogoProps): ReactElement {
  if (url) {
    return (
      <Box
        display="flex"
        alignItems="center"
        component={Link}
        to={url}
        target={openInNewTab ? "_blank" : "_self"}
      >
        <LogoElement {...rest} />
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center">
      <LogoElement {...rest} />
    </Box>
  );
}

type LogoElementProps = {
  svgCs?: string;
  svgEn?: string;
  svg?: string;
  height?: number;
  alt?: string;
};

function LogoElement({
  svgCs,
  svgEn,
  svg,
  height,
  alt,
}: LogoElementProps): ReactElement {
  const { tt, language } = useTT();

  const svgImg =
    (language === "cs" ? (svgCs ?? svg) : (svgEn ?? svg)) || defaultLogo;

  return (
    <img
      src={`/assets/logo/${svgImg}`}
      style={{
        height,
      }}
      alt={alt ?? tt("appLogo.alt")}
    />
  );
}
